<template>
    <div class="more_filter">
        <div v-for="(item, index) in searchObjList" :key="item.param">
            <el-popover
                :ref="`popover${index}`"
                placement="bottom-start"
                trigger="click">
                <MoreFilterItem :filter-item="item" @pushTab="pushTab" :ref="`MoreFilterItem${index}`"/>
                <div slot="reference">
                    <div class="more_filter_item" v-if="!item.isSearch" @click="itemClick(index)">
                        <span class="more_filter_item_text">{{ item.name }}</span>
                        <i class="el-icon-arrow-down el-icon--right more_filter_item_icon"></i>
                    </div>
                    <div class="more_filter_item_checked" v-if="item.isSearch" @click="itemClick(index)" @mouseenter="clearBtnShow(index)" @mouseleave="clearBtnHidden(index)">
                        <span class="more_filter_item_checked_text">{{ `${item.name}：${item.label}` }}</span>
                        <i class="el-icon-arrow-down el-icon--right more_filter_item_icon"></i>
                        <i class="el-icon-error more_filter_item_clear_icon" @click.stop="clearTab(index)" v-if="item.clearBtnShow"></i>
                    </div>
                </div>
            </el-popover>
        </div>
    </div>
</template>

<script>
    import MoreFilterItem from './MoreFilterItem';

    export default {
        props: {
            moreSearchItems: {
                type: Array,
                default: () => []
            }
        },
        components: {
            MoreFilterItem
        },
        created() {
            this.searchObjList = this.moreSearchItems.map(e => {
                return {
                    ...e,
                    isSearch: false,
                    clearBtnShow: false
                }
            });
        },
        data() {
            return {
                popoverIndex: null,
                searchObj: [],
                searchObjList: []
            }
        },
        watch: {
            searchObj: {
                deep: true,
                handler() {
                    let moreSearchValue = {};
                    this.searchObj.forEach(tags => {
                        switch (tags.type) {
                            case 'numberRange':
                                moreSearchValue[`${tags.param}Min`] = tags.value[0];
                                moreSearchValue[`${tags.param}Max`] = tags.value[1];
                                break;
                            case 'numberRangeArr':
                                moreSearchValue[`${tags.param}`] = tags.value;
                                break;
                            case 'dateRangeArr':
                                moreSearchValue[`${tags.param}`] = tags.value;
                                break;
                            default:
                                moreSearchValue[tags.param] = tags.value;
                                break;
                        }
                    })
                    this.$emit('pushTab', moreSearchValue);
                }
            }
        },
        methods: {
            itemClick(index) {
                this.popoverIndex = index;
            },
            clearBtnShow(index) {
                this.searchObjList[index].clearBtnShow = true;
            },
            clearBtnHidden(index) {
                this.searchObjList[index].clearBtnShow = false;
            },
            reset() {
                this.searchObjList.forEach((item, index) => {
                    if (item.defaultSearchValue !== undefined) {
                        this.$refs[`MoreFilterItem${index}`][0].getDefaultFilterItem();
                    } else {
                        item.isSearch = false;
                        item.label = '';
                        item.value = '';
                        item.clearBtnShow = false;
                        const i = this.searchObj.findIndex(item => item.param === this.searchObjList[index].param);
                        if (i !== -1) {
                            this.searchObj.splice(i, 1);
                        }
                        this.$refs[`MoreFilterItem${index}`][0].clear();
                    }
                });
            },
            clearAllTab() {
                this.searchObjList.forEach((item, index) => {
                    item.isSearch = false;
                    item.label = '';
                    item.value = '';
                    item.clearBtnShow = false;
                    this.$refs[`MoreFilterItem${index}`][0].clear();
                })
                this.searchObj = [];
            },
            clearTab(index) {
                this.popoverIndex = index;
                this.$refs[`popover${this.popoverIndex}`][0].doClose();
                this.searchObjList[index].isSearch = false;
                this.searchObjList[index].label = '';
                this.searchObjList[index].value = '';
                this.searchObjList[index].clearBtnShow = false;
                const i = this.searchObj.findIndex(item => item.param === this.searchObjList[index].param);
                if (i !== -1) {
                    this.searchObj.splice(i, 1);
                }
                this.$refs[`MoreFilterItem${index}`][0].clear();
            },
            pushTab(tags) {
                if (!tags.value || tags.value.length === 0) {
                    this.clearTab(this.popoverIndex);
                    return;
                }
                this.searchObjList = this.searchObjList.map(e => {
                    if (e.param === tags.param) {
                        e.isSearch = true;
                        e.label = tags.label;
                    }
                    return e;
                });
                let i = this.searchObj.findIndex(item => item.param === tags.param);
                if (i === -1) {
                    this.searchObj.push(tags);
                } else {
                    this.searchObj.splice(i, 1, tags);
                }
                if (this.popoverIndex !== null) {
                    this.$refs[`popover${this.popoverIndex}`][0].doClose();
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .more_filter {
        display: flex;
        flex-wrap: wrap;
        margin: 10px 0px 8px 10px;
    }
    .more_filter_item {
        margin: 0 8px 0 0;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        border-radius: 3px;
        cursor: pointer;
        &:hover {
            background-color: #e6e6e6;
        }
    }
    .more_filter_item_text {
        padding: 0 8px;
        font-size: 14px;
        color: #666;
    }
    .more_filter_item_checked {
        position: relative;
        display: inline-block;
        margin: 0 8px 0 0;
        height: 28px;
        line-height: 28px;
        font-size: 14px;
        cursor: pointer;
        background-color: #e6e6e6;
        border-radius: 3px;
    }
    .more_filter_item_checked_text {
        padding: 0 8px;
        font-size: 14px;
        font-weight: 700;
        color: #333;
    }
    .more_filter_item_icon {
        margin: 0 4px;
        font-size: 10px;
        color: #666;
    }
    .more_filter_item_clear_icon {
        position: absolute;
        font-size: 14px;
        color: #666;
        top: -7px; /* 距离顶部为0像素 */
        right: -7px; /* 距离右侧为0像素 */
    }
</style>
